
import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {UserResponse} from "../../classes/user-response";


@Component({
  selector: 'mobile-num-type',
  templateUrl: './mobile-num-type.component.html',
  styleUrls: ['./mobile-num-type.component.css']
})
export class MobileNumTypeComponent implements OnInit{

  //self explanatory

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Input() userRes : string[];
  @Input() question_number : number;
  @Output() user_Resp  = new EventEmitter<string[]>();
  @Input() indexOfRepeater : number;

  mobile : number;


  ngOnInit(){

    if(this.userRes[0].length > 0){

      let m = parseInt(this.userRes[0]);
      if(!isNaN(m)){
        this.mobile = m;
      }
    }

  }

  onPress(event : any){
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  onKey(event: any) {
    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  onEnter(event : any){
    this.mobile = parseInt(event.target.value);
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.mobile.toString()]);
  }



}



// WEBPACK FOOTER //
// ./src/app/questions-type/mobile-num-type/mobile-num-type.component.ts